import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable, of } from 'rxjs';

@Injectable()
export class ConnectExcelService {

    private _getExcelConnectors = 'api/ExternalSystem/ExcelConnector';

    constructor(private _restApi: RestApi) { }

    public getExcelConnectors(): Observable<IExcelConnector[]> {
        return this._restApi.get(this._getExcelConnectors);
    }

    public getExcelConnectorDetailVersion(guidVersion: string): Observable<IExcelVersionConnector> {
        return this._restApi.get(`${this._getExcelConnectors}/${guidVersion}`);
    }

    public uploadExcelFile(id: string, file: any, connectorId:any): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', file);

        return this._restApi
            .postFile(`${this._getExcelConnectors}/File/${id}/connector/${connectorId}`, formData);
    }

    public downloadExcelFile(fileId: string): Observable<any> {
        return this._restApi.requestBlob({ url: `${this._getExcelConnectors}/File/${fileId}`, parameters: [], body: {} }, 'GET');
    }

}